import * as Sentry from '@sentry/vue';
import axios, { AxiosError } from 'axios';
import { Notify, Platform } from 'quasar';
import { boot } from 'quasar/wrappers';
import { Network } from 'src/../src-capacitor/node_modules/@capacitor/network';
import { translate } from 'src/boot/i18n';
import { LOCALSTORAGE } from 'src/composables/const';
import usePlatformHelpers from 'src/composables/platformHelpers';
import { useUserStore } from 'src/store/userStore';
import { v4 as uuidv4 } from 'uuid';

export enum STATUS_CODES {
  NOT_FOUND = 404,
}
export enum HEADERS {
  INSTALL_ID = 'install_id',
  PLATFORM = 'platform',
}

export default boot(({}) => {
  const user = useUserStore();
  const { whichBrowser, whichPlatform } = usePlatformHelpers();

  axios.interceptors.request.use(
    async (request) => {
      const status = await Network.getStatus();
      if (!status.connected) {
        return Promise.reject(
          Notify.create({
            message: translate('noInternetConnection'),
            icon: 'ion-wifi',
            badgeClass: 'hidden',
          })
        );
      }

      let platform: string;
      if (Platform.is.capacitor) {
        platform = whichPlatform();
        let install_id = localStorage.getItem(LOCALSTORAGE.INSTALL_ID);
        if (!install_id) {
          install_id = uuidv4();
          localStorage.setItem(LOCALSTORAGE.INSTALL_ID, install_id);
        }

        // Set install_id header using AppsFlyer uid
        request.headers[HEADERS.INSTALL_ID] = install_id;
      } else {
        platform = whichBrowser();
      }

      // Set platform header
      request.headers[HEADERS.PLATFORM] = platform;
      // Set token header
      if (user.token?.length) {
        request.headers['Authorization'] = `Bearer ${user.token}`;
      }

      return request;
    },
    (error) => {
      void Promise.reject(error);
    }
  );

  axios.interceptors.response.use(
    (success) => {
      return success;
    },
    async (error: AxiosError) => {
      Sentry.captureException(error);
      return Promise.reject(error);
    }
  );
});
